import React, { useState,useEffect} from "react";
import { Modal, Radio, Switch, Form, Input,message } from 'antd';
import type { RadioChangeEvent } from 'antd';
import { addBill,editBill } from '@/api/personal-center'
import UModal from '@/components/modal';
import { IInvoiceItem } from '../../type';
import './index.scss'


interface IInvoice {
  showModal: boolean,
  setShowAddModal: (val: boolean) => void,
  invoiceItem?:any
  
}
const InvoiceModal: React.FC<IInvoice> = (props) => {
  const [invoiceType, setInvoiceType] = useState<number>(1);//普票1和专票3
  const [invoiceHeader, setInvoiceHeader] = useState<number>(1);//个人1，单位2
  const [isSwitch, setIsSwitch] = useState<boolean>(false); // 0 不是，1是
  const [headerName, setHeaderName] = useState<string>('');
  const [showPersonTips, setShowPersonTips] = useState(false);

  const { showModal, setShowAddModal, invoiceItem = {} } = props;
  const [form] = Form.useForm();
//  console.log(invoiceItem,Object.keys(invoiceItem).length,'invoiceItemsyvia')
  useEffect(() => {
    form.resetFields();
    setHeaderName('');
    setInvoiceType(1);
    setInvoiceHeader(1);
    setIsSwitch(false);
    //编辑
    if (invoiceItem&&Object.keys(invoiceItem).length>0) { 
      const formData =JSON.parse(JSON.stringify(invoiceItem)) 
      form.setFieldsValue({ ...formData});
      if (invoiceItem?.defaultStatus === 1) {
        setIsSwitch(true);
      } else { 
        setIsSwitch(false);
      }
      setHeaderName(invoiceItem.header);
      if (invoiceItem?.type === 1) {
        setInvoiceType(invoiceItem?.type);
        setInvoiceHeader(invoiceItem?.type);
      }else if (invoiceItem?.type === 2) { 
        setInvoiceType(1);
        setInvoiceHeader(invoiceItem?.type);
      }else { 
        setInvoiceType(invoiceItem?.type);
      }
    }
},[invoiceItem])
  const handleOk = () => {
    if (invoiceType===1&&invoiceHeader === 1) { 
      if (!headerName ||headerName.trim()==='') { //个人发票抬头
        setShowPersonTips(true);
        return false;
      }
    }
   
   const apis = invoiceItem && Object.keys(invoiceItem).length > 0 ? editBill : addBill;
    form.validateFields().then((values) => {
          const type = invoiceType === 1 ? invoiceHeader : invoiceType;
          const defaultStatus = isSwitch ? 1 : 0;
          // const header= headerName?headerName:values.orgName;
          const header= (invoiceType===1&&invoiceHeader===1)?headerName:values.orgName;
          const id=invoiceItem && Object.keys(invoiceItem).length > 0? invoiceItem.id : '';
          apis({ ...values, header, type, defaultStatus,id }).then((res:any) => { 
            if (res.success) {
              message.success('操作成功');
              setShowAddModal(false);
              form.resetFields();
              setHeaderName('');
              setInvoiceType(1);
              setInvoiceHeader(1);
              setIsSwitch(false);
              setShowAddModal(false);
            } else { 
              message.error(res.message)
            }
          })
        
      }).catch((errorInfo) => {
        // 处理表单验证错误
        console.log('表单验证失败:', errorInfo);
      });
  };

  const handleCancel = () => {
    setShowAddModal(false);
    form.resetFields();
    setHeaderName('');
    setInvoiceType(1);
    setInvoiceHeader(1);
    setIsSwitch(false);
    setShowPersonTips(false);
  };

  const handleChange = (e:RadioChangeEvent) => { 
    setInvoiceType(e.target.value);
      // 先清空数据
    form.resetFields();
    setIsSwitch(false);
    setShowPersonTips(false);
    if (e.target.value === 1) { 
      setInvoiceHeader(1);
    }
  }

  const handleHeaderChange = (e:RadioChangeEvent) => { 
    setInvoiceHeader(e.target.value);
    setIsSwitch(false);
    setShowPersonTips(false);
  }

  const handleSwitch = () => { 
    setIsSwitch(!isSwitch);
  }

  const handleHeader = (e: any) => {
    setHeaderName(e.target.value.trim());
    if (e.target.value.trim() === '') {
      setShowPersonTips(true);
      return false;
    } else { 
     
      setShowPersonTips(false);
    }
    // setShowPersonTips(false);
  }
 
  return <UModal
    centered
    width={900}
    title={invoiceItem && Object.keys(invoiceItem).length > 0 ? '编辑发票抬头' : '新增发票抬头'}
    open={showModal}
    // initialValues={editModalState}
    cancelText="取消"
    okText="保存"
    onCancel={handleCancel}
    onOk={handleOk}
    className="invoice-add-modal"
  >
    <Form
      form={form}
      layout="vertical"
      autoComplete="off"
      
    >
      <Form.Item label={
    <>
      <span style={{ color: 'red' }}>*&nbsp;</span>
      <span>发票类型</span>
    </>
  }
      >
        <Radio.Group
          disabled={ invoiceItem&&Object.keys(invoiceItem).length>0?true:false}
          // name="radiogroup"
          defaultValue={invoiceType}
          value={invoiceType }
          options={[
            { value: 1, label: '数电普通发票' },
            { value: 3, label: '数电专用发票' },
          ]}
          onChange={handleChange}
        />
      </Form.Item>
      {invoiceType === 1 && <Form.Item  label={
    <>
      <span style={{ color: 'red' }}>*&nbsp;</span>
      <span>发票抬头</span>
    </>
  } 
        // rules={[{ required: true }]}
      >
        <Radio.Group
          disabled={invoiceItem&& Object.keys(invoiceItem).length>0?true:false}
          // name="radiogroup"
          defaultValue={invoiceHeader}
          value={invoiceHeader }
          options={[
            { value: 1, label: '个人' },
            { value: 2, label: '单位' },
          ]}
          onChange={handleHeaderChange}
        />
        {invoiceHeader === 1 &&
          <>
          <Input
            maxLength={255}
            value={headerName}
            className="invoice-header"
            onChange={(e) => handleHeader(e)}
          />
          {showPersonTips && <span className="person-tips">请输入个人抬头信息</span>}
          </>
          } 
      </Form.Item>}
     {/* 专票*/}
     {invoiceType===3&&<><Form.Item
        label="单位名称"
        name="orgName"
        getValueFromEvent={(e) => {
          const value = typeof e === 'object' && e.target ? e.target.value : e;
          return value?.trim();
        }}
        rules={[
          { required: true, message: '请输入单位名称' },
        ]}
      >
        <Input maxLength={255} />
      </Form.Item>
      <Form.Item
        label="纳税人识别号"
          name="code"
          getValueFromEvent={(e) => {
            const value = typeof e === 'object' && e.target ? e.target.value : e;
            return value?.trim();
          }}
        rules={[
          { required: true, message: '请输入纳税人识别号' },
          // {
          //   pattern: /^1[3-9]\d{9}$/,
          //   message: '纳税人识别号错误，请重新输入',
          // },
        ]}
      >
        <Input maxLength={25} />
      </Form.Item>
      <Form.Item
        label="注册地址"
          name="address"
          getValueFromEvent={(e) => {
            const value = typeof e === 'object' && e.target ? e.target.value : e;
            return value?.trim();
          }}
        rules={[
          { required: true, message: '请输入注册地址' },
        ]}
      >
        <Input maxLength={255} />
      </Form.Item>
      <Form.Item
        label="注册电话"
          name="tel"
          getValueFromEvent={(e) => {
            const value = typeof e === 'object' && e.target ? e.target.value : e;
            return value?.trim();
          }}
        rules={[
          { required: true, message: '请输入注册电话' },
          {
            pattern: /^[0-9-]{0,20}$/,
            message: '注册电话错误，请重新输入',
          },
        ]}
      >
        <Input maxLength={20} />
      </Form.Item>
      <Form.Item
        label="开户银行"
          name="bankName"
          getValueFromEvent={(e) => {
            const value = typeof e === 'object' && e.target ? e.target.value : e;
            return value?.trim();
          }}
        rules={[
          { required: true, message: '请输入开户银行' },
        ]}
      >
        <Input maxLength={255} />
      </Form.Item>
      <Form.Item
        label="开户行账号"
          name="bankAccount"
          getValueFromEvent={(e) => {
            const value = typeof e === 'object' && e.target ? e.target.value : e;
            return value?.trim();
          }}
        rules={[
          { required: true, message: '请输入开户行账号' },
          {
            pattern: /^[0-9]{0,50}$/,
            message: '开户行账号错误，请重新输入',
          },
        ]}
      >
        <Input maxLength={50} />
        </Form.Item></>} 
       {/* 普票1、单位2*/}
     {invoiceType===1&&invoiceHeader===2&&<><Form.Item
        label="单位名称"
        name="orgName"
        getValueFromEvent={(e) => {
          const value = typeof e === 'object' && e.target ? e.target.value : e;
          return value?.trim();
        }}
        rules={[
          { required: true, message: '请输入单位名称' },
        ]}
      >
        <Input maxLength={255} />
      </Form.Item>
      <Form.Item
        label="纳税人识别号"
          name="code"
          getValueFromEvent={(e) => {
            const value = typeof e === 'object' && e.target ? e.target.value : e;
            return value?.trim();
          }}
        rules={[
          { required: true, message: '请输入纳税人识别号' },
        ]}
      >
        <Input maxLength={25} />
      </Form.Item>
      <Form.Item
        label="注册地址"
        name="address"
      >
        <Input maxLength={255} />
      </Form.Item>
      <Form.Item
        label="注册电话"
        name="tel"
        // rules={[
        //   { required: true, message: '请输入手机号码' },
        //   {
        //     pattern: /^[0-9-]{0,20}$/,
        //     message: '注册电话错误，请重新输入',
        //   },
        // ]}
      >
        <Input maxLength={20} />
      </Form.Item>
      <Form.Item
        label="开户银行"
        name="bankName"
      >
        <Input maxLength={255} />
      </Form.Item>
      <Form.Item
        label="开户行账号"
        name="bankAccount"
      >
        <Input maxLength={50} />
      </Form.Item></>} 
      {(invoiceItem===null ||invoiceItem&&Object.keys(invoiceItem)?.length<=0) && <>
        <span className='switch-text'>设为默认抬头</span>
        <Switch value={isSwitch} onChange={handleSwitch} />
      </>}
      <p className="invoice-tips">订单付款后即可在订单详情申请您的数电{ invoiceType===1?'普通':'专用'}发票</p>
    </Form>
  </UModal>
}

export default InvoiceModal;
